export default "__VITE_ASSET__Bv4giSkI__"